'use strict';
angular.module('schoolLinqApp').factory('utilsService', [
	'$http',
	function ($http) {
		// retrieve string values of an auto-complete list
		function getACList(listName) {
			return $http.get('/api/autocomplete-list/simple/' + listName);
		}

		var endpoint = '/api/utils';

		function getStates() {
			return $http.get(endpoint + '/states');
		}

		function getCheckLayout() {
			return $http.get(endpoint + '/checkLayout');
		}

		function getCheckMemoLocation() {
			return $http.get(endpoint + '/checkMemoLocation');
		}

		function getDaysOfWeek() {
			return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		}

		function getMonths() {
			return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
		}

		function getBillingMethods() {
			return $http.get(endpoint + '/billingMethods');
		}

		function getjournalCodes() {
			return $http.get(endpoint + '/journalCodes');
		}

		function getARInvoiceStatus() {
			return $http.get(endpoint + '/ar_InvoiceStatus');
		}

		function getVendorStatuses() {
			return $http.get(endpoint + '/vendorStatuses');
		}

		function getBankStatuses() {
			return $http.get(endpoint + '/bankStatuses');
		}

		function getPurchaseOrderStatuses() {
			return $http.get(endpoint + '/purchaseOrderStatuses');
		}

		function getTaxRateTypes() {
			return $http.get(endpoint + '/taxRateTypes');
		}

		function getPRBankAccountTypes() {
			return $http.get(endpoint + '/prBankAccountTypes');
		}

		function getMethodOfPaymentTypes() {
			return $http.get(endpoint + '/methodOfPaymentTypes');
		}

		function getInvoiceStatus() {
			return $http.get(endpoint + '/invoiceStatus');
		}

		function getARTerms() {
			return $http.get(endpoint + '/arTerms');
		}

		function getPRFLSATypes() {
			return $http.get(endpoint + '/prFLSATypes');
		}

		function getPRPayFrequencies() {
			return $http.get(endpoint + '/prPayFrequencies');
		}

		function getPRPayTypes() {
			return $http.get(endpoint + '/prPayTypes');
		}

		function getPRTimeUnit() {
			return $http.get(endpoint + '/prtimeunit');
		}

		function getPRAbsenceDeductionTypes() {
			return $http.get(endpoint + '/prabsencededuction');
		}

		function getPRDeductionTypes() {
			return $http.get(endpoint + '/prdeductiontypes');
		}

		function getDeductionTypes() {
			return $http.get(endpoint + '/deductionTypes');
		}

		function getW2Boxs() {
			return $http.get(endpoint + '/w2Boxs');
		}

		function getEmployeeStatuses() {
			return $http.get(endpoint + '/employeeStatuses');
		}

		function getEmployeeMaritalStatuses() {
			return $http.get(endpoint + '/employee-marital-statuses');
		}

		function getRaces() {
			return $http.get(endpoint + '/races');
		}

		function getTerminationReasons() {
			return $http.get(endpoint + '/terminationReasons');
		}
		function getOrbitContractCodes() {
			return $http.get(endpoint + '/orbitContractCodes');
		}

		function getOrbitPlanCodes() {
			return $http.get(endpoint + '/orbitPlanCodes');
		}

		function getOrbitPrimaryJobClasses() {
			return $http.get(endpoint + '/orbitPrimaryJobClasses');
		}

		function getTaxFilingStatuses() {
			return $http.get(endpoint + '/taxFilingStatuses');
		}

		function getOtherPayTypes() {
			return $http.get(endpoint + '/otherPayTypes');
		}

		function getTaxMethods() {
			return $http.get(endpoint + '/taxMethods');
		}

		function getTINTypes() {
			return $http.get(endpoint + '/tinTypes');
		}

		function getTimeZones() {
			return $http.get(endpoint + '/timeZones');
		}

		function getRequestStatuses() {
			return $http.get(endpoint + '/requestStatuses');
		}

		function getPRDeductionFrequencies() {
			return $http.get(endpoint + '/prDeductionFrequencies');
		}

		function getVendor1099Boxes() {
			return $http.get(endpoint + '/vendor-1099-boxes');
		}

		function getBeginningTeacherStatuses() {
			return $http.get(endpoint + '/beginning-teacher-statuses');
		}

		return {
			getACList: getACList,
			getStates: getStates,
			getMonths: getMonths,
			getDaysOfWeek: getDaysOfWeek,
			getCheckLayout: getCheckLayout,
			getCheckMemoLocation: getCheckMemoLocation,
			getjournalCodes: getjournalCodes,
			getBillingMethods: getBillingMethods,
			getARInvoiceStatus: getARInvoiceStatus,
			getVendorStatuses: getVendorStatuses,
			getBankStatuses: getBankStatuses,
			getPurchaseOrderStatuses: getPurchaseOrderStatuses,
			getTaxRateTypes: getTaxRateTypes,
			getPRBankAccountTypes: getPRBankAccountTypes,
			getMethodOfPaymentTypes: getMethodOfPaymentTypes,
			getInvoiceStatus: getInvoiceStatus,
			getARTerms: getARTerms,
			getPRFLSATypes: getPRFLSATypes,
			getPRPayFrequencies: getPRPayFrequencies,
			getPRPayTypes: getPRPayTypes,
			getPRTimeUnit: getPRTimeUnit,
			getPRAbsenceDeductionTypes: getPRAbsenceDeductionTypes,
			getPRDeductionTypes: getPRDeductionTypes,
			getDeductionTypes: getDeductionTypes,
			getW2Boxs: getW2Boxs,
			getEmployeeStatuses: getEmployeeStatuses,
			getEmployeeMaritalStatuses: getEmployeeMaritalStatuses,
			getOrbitContractCodes: getOrbitContractCodes,
			getOrbitPlanCodes: getOrbitPlanCodes,
			getOrbitPrimaryJobClasses: getOrbitPrimaryJobClasses,
			getRaces: getRaces,
			getTerminationReasons: getTerminationReasons,
			getTaxFilingStatuses: getTaxFilingStatuses,
			getOtherPayTypes: getOtherPayTypes,
			getTaxMethods: getTaxMethods,
			getTINTypes: getTINTypes,
			getTimeZones: getTimeZones,
			getRequestStatuses: getRequestStatuses,
			getPRDeductionFrequencies: getPRDeductionFrequencies,
			getVendor1099Boxes: getVendor1099Boxes,
			getBeginningTeacherStatuses: getBeginningTeacherStatuses,
		};
	},
]);
